
import { ApplicationUserModel, UnitOfMeasureModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Ref } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { scrapCausesStore as unitOfMeasuresStore } from '@/libs/unit-of-measure/+state/store';

@Component({})
export default class UnitOfMeasureDialog extends Page {
    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    unitOfMeasure: UnitOfMeasureModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.unitOfMeasure?.id == Guid.EmptyGuid();
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    private load(): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadUnitOfMeasure()
                    .then((e) => {
                        this.loading = false;
                        resolve(e);
                    })
                    .catch((e: any) => {
                        reject(e);
                    });
            });
        } else {
            this.unitOfMeasure = {
                id: Guid.EmptyGuid(),
                code: null,
                name: null,
                shortCode: null,
            } as UnitOfMeasureModel;
            return new Promise((resolve) => resolve(null));
        }
    }

    private loadUnitOfMeasure() {
        return new Promise((resolve, reject) => {
            unitOfMeasuresStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(unitOfMeasuresStore, CrudReponse.Get)
                .then((e) => {
                    this.unitOfMeasure = e;
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    private save() {
        if (this.form.validate()) {
            const unitOfMeasure = { ...this.unitOfMeasure } as UnitOfMeasureModel;
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                unitOfMeasuresStore.dispatch(CrudAction.Create, { item: unitOfMeasure });
                this.subscribe(unitOfMeasuresStore, CrudReponse.Create)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            } else {
                unitOfMeasuresStore.dispatch(CrudAction.Update, { item: unitOfMeasure });
                this.subscribe(unitOfMeasuresStore, CrudReponse.Update)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            }
        }
    }

    deleteClick() {
        this.deleteDialog = true;
    }

    deleteUnitOfMeasure() {
        this.deleting = true;
        unitOfMeasuresStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(unitOfMeasuresStore, CrudReponse.Delete)
            .then(() => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch(() => {
                this.deleting = false;
            });
    }
}
